/** ESCHER FALLS — Tiếng Việt。 */

import type { Strings } from './ja';

export const VI: Strings = {
  pour: 'Xả nước',
  lever: 'Cần gạt',
  leverAria: 'Gạt cần',
  retry: 'Làm lại',
  again: 'Một lần nữa',
  next: 'Tiếp',
  share: 'Chia sẻ khung này',
  shareFailed: 'Không chia sẻ được',
  rotateLeft: 'Quay góc nhìn sang trái',
  rotateRight: 'Quay góc nhìn sang phải',
  tiltUp: 'Nâng góc nhìn',
  tiltDown: 'Hạ góc nhìn',
  topDown: 'Từ trên xuống',
  water: (left, total) => `Nước ${left} / ${total}`,
  moves: (left, total) => `Lượt quay ${left} / ${total}`,
  timeLeft: (time) => `Còn ${time}`,
  drops: (n) => `${n} giọt`,

  resultClear: 'Nước đã chảy qua',
  resultFail: 'Nước không chảy qua',
  clearTitle: 'Nước đã chảy',
  fail: {
    time: 'Hết thời gian',
    moves: 'Hết lượt quay',
    drywell: 'Nước chảy vào giếng cạn',
    water: 'Hết nước',
    deadend: 'Nước rơi vào đường cụt',
  },
  extendByAd: 'Xem quảng cáo để thêm 30 giây',
  extendByDrops: (cost) => `${cost} giọt để thêm 30 giây`,
  multiplyByAd: (mult) => `Xem quảng cáo nhận ×${mult} giọt`,

  stages: 'Màn',
  settingsAria: 'Cài đặt',
  menuAria: 'Menu',
  back: 'Quay lại',
  loop1: 'Vòng một',
  loop2: 'Vòng hai',
  loopNote: 'Vòng hai siết chặt lượt quay và thời gian. Kỷ lục được lưu riêng.',
  shop: 'Cửa hàng',
  groupMain: 'Phần chính',
  groupExtra1: 'Phần thêm',
  groupExtra2: 'Phần thêm II',
  freeTrial: 'Miễn phí',
  notPurchased: (n, name) => `${n} ${name} (chưa mua)`,
  lockedStage: 'Màn chưa mở',
  extraLockedFree: 'Màn 1 “Thác chảy ngược” chơi miễn phí. Các màn còn lại mở khi mua trong Cài đặt (≡).',
  extraLocked: 'Mở khi mua trong Cài đặt (≡).',
  extra2Locked: 'Từ màn 11 trở đi sẽ mở khi nước đã chảy qua màn 1–10.',
  extra2LockedUnowned: 'Mua trong Cài đặt (≡), rồi hoàn thành màn 1–10 để mở từ màn 11 trở đi.',
  extra2Note: 'Mở khi nước đã chảy qua toàn bộ phần thêm.',
  progress: (cleared, total) => `Phần chính ${cleared} / ${total} đã xong`,
  totalTime: (time) => `Tổng ${time}`,
  totalNone: 'Tổng —',

  settings: 'Cài đặt',
  bgm: 'Âm nền',
  se: 'Hiệu ứng',
  testSound: 'Thử âm thanh',
  audioStatus: (state) => `Âm thanh: ${state}`,
  audioState: {
    locked: 'Chưa bật (chạm vào màn hình một lần)',
    running: 'Đang chạy',
    suspended: 'Tạm dừng',
  },
  demoNote: (n) => `${n} màn này là bản chơi thử trên web. Đủ 42 màn có trong ứng dụng.`,
  demoGet: 'Tải trên App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Màn hôm nay',
  dailyLoading: 'Đang tải…',
  dailyOffline: 'Không kết nối được nên chưa mở được màn hôm nay',
  dailyPlay: 'Chơi',
  dailyCleared: (time: string) => `Đã qua trong ${time}`,
  archiveTitle: 'Các màn trước',
  upcomingTitle: 'Các màn sắp tới',
  archiveLocked: '3 ngày gần nhất miễn phí. Mua Phần thêm để mở tất cả các màn cũ hơn',
  language: 'Ngôn ngữ',
  languageAuto: 'Theo thiết bị',
  palette: 'Bảng màu',
  worn: 'Đang dùng',
  owned: 'Đã có',
  buyDrops: 'Mua giọt nước',
  restore: 'Phục hồi giao dịch',
  writeReview: 'Đánh giá ứng dụng này',
  moreApps: 'Tác phẩm khác của tác giả',
  restoreChecking: 'Đang kiểm tra…',
  restoreDone: (n) => `Đã phục hồi ${n}`,
  restoreNone: 'Không có gì để phục hồi',
  restoreFailed: 'Không phục hồi được',
  chooseStage: 'Chọn màn',
  resume: 'Tiếp tục',

  prizeLabel: 'Thưởng',
  awardLabel: 'Danh hiệu',
  toExtra: 'Đến phần thêm',
  toLoop2: 'Đến vòng hai',
  toStart: 'Về đầu',
  allClearTitle: 'Đi hết',
  allClearBody: (n) => `Nước đã chảy qua cả ${n} đường nước`,
  multiplyTimes: (mult) => `Xem quảng cáo nhận ×${mult}`,
  noteRank: 'Danh hiệu được lưu lại và hiện phía trên danh sách màn.',
  noteLoop2: 'Vòng hai đã mở. Lượt quay và thời gian siết chặt hơn.',
  notePartOne: 'Phần Một đến đây là hết. Nước vẫn chưa dâng lên.',
  inviteTry: 'Thử Phần thêm 1',
  inviteOpen: 'Mở Phần thêm I — 20 màn',
  dateLine: (d) => `Ngày ${d.getDate()} tháng ${d.getMonth() + 1} năm ${d.getFullYear()}`,

  completionTitle: 'Người vượt cõi vô cùng',
  rank: {
    none: '—',
    sovereign: 'Bậc chế ngự dòng nước',
    architect: 'Người thiết kế thác',
    mason: 'Thợ đá',
    apprentice: 'Người học việc',
    wayfarer: 'Khách lữ hành',
  },

  skin: {
    hakushi: 'Giấy trắng',
    ai: 'Xanh chàm',
    koke: 'Xanh rêu',
    shu: 'Đỏ son',
    sumi: 'Mực sumi',
  },

  product: {
    drops600: '600 giọt',
    drops1600: '1.600 giọt',
    drops5000: '5.000 giọt',
    noads: 'Bỏ quảng cáo',
    extras: 'Phần thêm I — 21 màn (không quảng cáo)',
  },
};
